import styled from "styled-components";

const HomeSubtitle = styled.p`
  color: #000;
  font-size: 20px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 2;
`

export default HomeSubtitle
